import axios from 'axios'
export default {
  created() {
    this.getGroupConfig()
  },
  data() {
    return {
      clientGroupCategories: [],
      dealGroupingInfo: {},
    }
  },
  methods: {
    async getGroupConfig() {
      const params = {
        params: {
          clientId: this.clientId,
          marketId: this.marketId,
        },
      }

      const requests = [
        axios.get('/api/config/Client/getGroupCategories', params),
        axios.get('/api/config/Client/getDealGroupingInfo', params),
      ]

      const [clientGroupCategories, dealGroupingInfo] = await Promise.all(requests)
      this.clientGroupCategories = clientGroupCategories.data
      this.dealGroupingInfo = dealGroupingInfo.data
    },
    getDealCategoryValue(dealId, categoryId) {
      const dealItem = this.dealGroupingInfo.dealItems.find(
        x => x.dealId == dealId && x.groupCategoryId == categoryId,
      )
      if (dealItem) {
        if (dealItem.textValue) return dealItem.textValue

        const groupItem = this.dealGroupingInfo.items.find(
          x => x.groupItemId == dealItem.groupItemId,
        )

        return groupItem.name
      }

      return ''
    },
    refreshCategoryColumns() {
      return this.getGroupConfig()
    },
  },
  computed: {
    categoryColumns() {
      return this.clientGroupCategories.map(item => ({
        title: item.text,
        field: `groupCategory${item.value}`,
        template: dataItem => this.getDealCategoryValue(dataItem.dealId, item.value),
        width: 120,
      }))
    },
  },
}
